export enum LocaleType {
  en = 'English',
  fr = 'French',
}
